import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Popup, Flex } from 'nallian-shared-ui/lib/components';
import { NoBreakSpan } from '../../../../app/styles';

const CommunityMemberRoles = ({ value }) => {
  const { t } = useTranslation();

  if (!value?.length) {
    return <i>{t('noRoles')}</i>;
  }

  return (
    <Popup
      content={
        <Flex direction="column">
          {value.map(role => (
            <div key={role.id}>{role.name}</div>
          ))}
        </Flex>
      }
      on="hover"
      hoverable
      trigger={<NoBreakSpan>{t('rolesCount', { count: value.length })}</NoBreakSpan>}
    />
  );
};

CommunityMemberRoles.propTypes = {
  value: PropTypes.array,
};

CommunityMemberRoles.defaultProps = { value: [] };

export default CommunityMemberRoles;
